import React, { useState } from "react";
import { withAuth } from "./withAuth";
import { Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { Button, Text, Card, SimpleGrid } from "@mantine/core";
import AddCard from "../components/AddCard";
import Header from "../components/Header";
import axios from "axios";
import { API_URL } from "../config";

function SetCreator({ onCreateSet }) {
  const [flashcards, setFlashcards] = useState([]);
  const [front, setFront] = useState("");
  const [back, setBack] = useState("");
  const [title, setTitle] = useState("");
  const navigate = useNavigate();
  const userId = localStorage.getItem("userId");

  const titleSubmit = (e) => {
    e.preventDefault();
  };
  const handleSave = () => {
    const newSet = {
      title,
      userId,
      flashcards,
    };
    axios
      .post(`${API_URL}/set`, newSet)
      .then((response) => {
        const newSet = response.data.data;
        onCreateSet(newSet);
        navigate("/");
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const onSubmit = () => {
    const newCard = {
      front,
      back,
    };
    setFlashcards([...flashcards, newCard]);
    setFront("");
    setBack("");
  };

  return (
    <>
      <Header />
      <div
        style={{
          marginTop: "4rem",
          display: "flex",
          position: "absolute",
          width: "100vh",
          height: "50vh",
          top: "5%",
          left: "20%",
          gridTemplateColumns: "repeat(1fr, 2fr)",
          gridColumnGap: "20px",
          gridRowGap: "5px",
        }}
      >
        <AddCard
          front={front}
          back={back}
          setFront={setFront}
          setBack={setBack}
          onSubmit={onSubmit}
        />
        <Card
          style={{
            maxWidth: "500px",
            width: "50%",
            height: "240px",
            borderRadius: "10px",
          }}
        >
          <Form onSubmit={titleSubmit}>
            <Form.Group style={{ marginTop: "30px" }}>
              <Form.Label>Set Name</Form.Label>
              <Form.Control
                name="title"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
            </Form.Group>
            <Button
              color="green"
              variant="light"
              style={{ marginTop: "20px", left: "35%", borderRadius: "10px" }}
              onClick={handleSave}
              size="xl"
            >
              Save
            </Button>
          </Form>
        </Card>
      </div>
      <SimpleGrid style={{ marginTop: "20rem", marginLeft: "2.5rem" }} cols={4}>
        {flashcards.map((card, index) => (
          <Card
            key={index}
            style={{
              borderRadius: "10px",
              maxWidth: "300px",
              height: "200px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Text style={{ position: "relative" }} align="center" weight={700}>
              {card.front}
            </Text>
            <Text align="center">{card.back}</Text>
          </Card>
        ))}
      </SimpleGrid>
    </>
  );
}

export default withAuth(SetCreator);
